import { 
  ChatBubbleOutline, 
  PersonAdd, 
  Article, 
  School, 
  QuestionAnswer,
  Assignment,
  VideoLibrary,
  Link,
  Group,
  Visibility
} from "@mui/icons-material";
import { NOTIFICATION_TYPES } from "../../../notification-constants";

/**
 * Configuration for chat notifications
 */
export const CHAT_NOTIFICATION_CONFIG = {
  cardColor: "primary",
  actionColor: "primary",
  showTypeBadge: false,
  getNotificationIcon: () => <ChatBubbleOutline sx={{ fontSize: 18 }} />,
  getActionLabel: () => "Start Chat",
  getActionIcon: () => <PersonAdd sx={{ fontSize: 16 }} />,
};

/**
 * Configuration for content notifications
 */
export const CONTENT_NOTIFICATION_CONFIG = {
  cardColor: "secondary",
  actionColor: "secondary",
  showTypeBadge: true,
  getNotificationIcon: (type) => {
    switch (type) {
      case NOTIFICATION_TYPES.NEW_QUESTION:
        return <QuestionAnswer sx={{ fontSize: 18 }} />;
      case NOTIFICATION_TYPES.NEW_QUESTION_ANSWER:
      case NOTIFICATION_TYPES.NEW_CONTENT_ANSWER:
        return <Assignment sx={{ fontSize: 18 }} />;
      case NOTIFICATION_TYPES.NEW_VIDEO:
        return <VideoLibrary sx={{ fontSize: 18 }} />;
      case NOTIFICATION_TYPES.NEW_LINK:
        return <Link sx={{ fontSize: 18 }} />;
      case NOTIFICATION_TYPES.NEW_GROUP:
        return <Group sx={{ fontSize: 18 }} />;
      default:
        return <School sx={{ fontSize: 18 }} />;
    }
  },
  getActionLabel: (type) => {
    switch (type) {
      case NOTIFICATION_TYPES.NEW_QUESTION:
        return 'View Question';
      case NOTIFICATION_TYPES.NEW_QUESTION_ANSWER:
      case NOTIFICATION_TYPES.NEW_CONTENT_ANSWER:
        return 'View Answer';
      case NOTIFICATION_TYPES.NEW_VIDEO:
        return 'View Video';
      case NOTIFICATION_TYPES.NEW_LINK:
        return 'View Link';
      case NOTIFICATION_TYPES.NEW_GROUP:
        return 'View Group';
      default:
        return 'View Details';
    }
  },
  getActionIcon: () => <Visibility sx={{ fontSize: 16 }} />,
  getTypeBadgeIcon: (type) => {
    switch (type) {
      case NOTIFICATION_TYPES.NEW_QUESTION:
        return <QuestionAnswer sx={{ fontSize: 12 }} />;
      case NOTIFICATION_TYPES.NEW_QUESTION_ANSWER:
      case NOTIFICATION_TYPES.NEW_CONTENT_ANSWER:
        return <Assignment sx={{ fontSize: 12 }} />;
      case NOTIFICATION_TYPES.NEW_VIDEO:
        return <VideoLibrary sx={{ fontSize: 12 }} />;
      case NOTIFICATION_TYPES.NEW_LINK:
        return <Link sx={{ fontSize: 12 }} />;
      case NOTIFICATION_TYPES.NEW_GROUP:
        return <Group sx={{ fontSize: 12 }} />;
      default:
        return <School sx={{ fontSize: 12 }} />;
    }
  },
};
